module.exports = __webpack_public_path__ + "img/allergy-fish.b5e5694a.png";